import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { connect } from "react-redux";
import "../../lib/css/components/loading-toast.scss";

const Loading = ({ loading }) => {
  const { actief, soort, message } = loading;
  const [isVisible, setIsVisible] = useState(false);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (actief) {
      setShouldRender(true);
      // Small delay to trigger CSS animation
      requestAnimationFrame(() => setIsVisible(true));
    } else {
      setIsVisible(false);
      // Wacht op de exit animatie voordat we het component verwijderen
      setTimeout(() => {
        setShouldRender(false);
      }, 500); // Tijd voor slideOutDown animatie
    }
  }, [actief]);

  if (!shouldRender) {
    return null;
  }

  // Icon mapping voor verschillende soorten berichten
  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return 'fas fa-check-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'danger':
      case 'error':
        return 'fas fa-exclamation-circle';
      case 'info':
      default:
        return 'fas fa-info-circle';
    }
  };

  return createPortal(
    <div className={`loadingmessage toast-style animated-toast ${isVisible ? 'slide-in' : 'slide-out'}`}>
      <div className={`toast show border-0`} role="alert">
        <div className="toast-header">
          <i className={`${getIcon(soort)} me-2 text-${soort}`}></i>
          <strong className="me-auto">Status</strong>
          <small className="text-muted">nu</small>
        </div>
        <div className="toast-body">
          {message}
        </div>
      </div>
    </div>,
    document.body
  );
}

const mapStateToProps = (state) => ({
  loading: state.loading.message
});

export default connect(mapStateToProps)(Loading);
